import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import {DmsDataGrid} from '@dms/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface RequestsSegmentProps extends RequiredTestIdProps {
  orderItemId: string | Nullish;
}

export function RequestsSegment(props: RequestsSegmentProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {orderItemId: props.orderItemId}]),
    [props.orderItemId]
  );

  return (
    <DmsDataGrid
      gridCode="warehouse-supplier-order-item-requests"
      queryModifier={queryModifier}
      autoHeight
      data-testid={suffixTestId('requests', props)}
    />
  );
}
